import axios from './configAxiosOrganizations';

export const postCreateWorkerOrg = async (requestData) => {
	return await axios.post(`/worker/create/`, requestData);
};
